<template>
  <div class="chat-notification">
    <slot />
    <div
      v-if="number"
      class="chat-notification__badge"
      :style="{
        width: notificationWidth
      }"
    >
      {{ number > 99 ? '99+': number }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatNotification',
  props: {
    number: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    notificationWidth() {
      if (this.number < 10) {
        return '14px';
      }

      if (this.number > 99) {
        return '24px';
      }

      return '20px';
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-notification{
    display: inline;
    position: relative;
    min-width: 10px;
    padding: 0px;

    &__badge{
        position: absolute;
        background-color: $clementine;
        border-radius: 10px;
        color: $black;
        font-family: $font-family-sans-serif-medium;
        font-size: 0.625rem;
        top: -5px;
        left: 15px;
        width: 14px;
        height: 14px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
    }
}
</style>
